var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-items-center justify-content-center" },
    [
      _vm.showPreview
        ? _c(
            "v-col",
            { attrs: { cols: "12", lg: "4" } },
            [
              _c(
                "material-card",
                { staticClass: "v-card-profile" },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "mx-auto d-block",
                      attrs: { slot: "offset", size: "130" },
                      slot: "offset",
                    },
                    [_c("v-img", { attrs: { src: _vm.image } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-text", { staticClass: "text-xs-center" }, [
                    _c("h4", { staticClass: "card-title fw-light" }, [
                      _vm._v(_vm._s(_vm.form.name)),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-col", { attrs: { cols: "12", lg: "8" } }, [
        _c(
          "div",
          { staticClass: "bg-white p-4", attrs: { wrap: "" } },
          [
            _c(
              "v-flex",
              [
                _c("v-text-field", {
                  staticClass: "purple-input",
                  attrs: {
                    label: "名前",
                    placeholder: "お名前を書いてください",
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isGuestUpdate
              ? _c("v-flex", { staticClass: "mb-3" }, [
                  _c("input", {
                    attrs: { type: "file" },
                    on: { change: _vm.onFileChange },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _vm.user && _vm.user.unconfirmedEmail
                  ? _c("span", { staticClass: "confirm_mail" }, [
                      _vm._v(
                        "\n          現在変更確認中のメールアドレス： " +
                          _vm._s(_vm.user.unconfirmedEmail) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("v-text-field", {
                  staticClass: "purple-input",
                  attrs: {
                    label: "メールアドレス",
                    placeholder: "メールアドレスを書いてください",
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c("v-text-field", {
                  staticClass: "purple-input",
                  attrs: { type: "password", label: "パスワード" },
                  model: {
                    value: _vm.form.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c("v-text-field", {
                  staticClass: "purple-input",
                  attrs: { type: "password", label: "パスワード（再入力）" },
                  model: {
                    value: _vm.form.newPassword,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "newPassword", $$v)
                    },
                    expression: "form.newPassword",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c("v-text-field", {
                  staticClass: "purple-input",
                  attrs: {
                    color: !_vm.form.isSamePass ? "red" : "primary",
                    type: "password",
                    label: "パスワード（再入力）",
                  },
                  model: {
                    value: _vm.form.newPasswordConfirmation,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "newPasswordConfirmation", $$v)
                    },
                    expression: "form.newPasswordConfirmation",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.schoolSetting &&
            _vm.schoolSetting.allowUserEditGroup &&
            !_vm.isGuestUpdate
              ? _c(
                  "v-flex",
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.groups,
                        "item-text": "name",
                        "item-value": "id",
                        label: "所属",
                        dense: "",
                      },
                      model: {
                        value: _vm.form.userBlockId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "userBlockId", $$v)
                        },
                        expression: "form.userBlockId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
                  _c("p", {
                    staticClass: "red--text",
                    domProps: { innerHTML: _vm._s(_vm.errorMessage) },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", "text-xs-right": "" } },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "update-btn me-2",
                    attrs: { color: "#7DD420" },
                    on: { click: _vm.onUpdate },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.isGuestUpdate
                            ? "ユーザー登録する"
                            : "ユーザー保存する"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isLoading
                  ? _c("v-progress-circular", {
                      staticClass: "loading",
                      attrs: { indeterminate: "", color: "green" },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { transition: "dialog-bottom-transition", "max-width": "600" },
          model: {
            value: _vm.completeDialog,
            callback: function ($$v) {
              _vm.completeDialog = $$v
            },
            expression: "completeDialog",
          },
        },
        [
          [
            _c(
              "v-card",
              [
                _c("v-toolbar", { attrs: { color: "primary", dark: "" } }, [
                  _vm._v("ユーザ更新完了"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-4 d-flex flex-column align-start" },
                  [
                    _c("div", { staticClass: "text-h5" }, [
                      _vm._v("ありがとございました"),
                    ]),
                    _vm._v(" "),
                    _vm.user.unconfirmedEmail
                      ? [
                          _c("div", { staticClass: "text-subtitle-1" }, [
                            _vm._v("メールを送りましたので確認してください"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-subtitle-1 text-warning" },
                            [
                              _vm._v(
                                "5分後にメールとどかない場合、メールアドレスを再入力しなおしてください"
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "v-card-actions",
                  { staticClass: "justify-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { depressed: "", color: "primary" },
                        on: {
                          click: function () {
                            _vm.completeDialog = false
                          },
                        },
                      },
                      [_vm._v("\n            閉じます\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }